
import { cn } from "@/lib/utils";
import { useImageFetcher } from "./useImageFetcher";

interface SituationImageProps {
  imageUrl: string;
  isMobile: boolean;
  section?: string;
  sectionId?: string;
}

const SituationImage = ({ 
  imageUrl, 
  isMobile, 
  section = "about-me-banner", 
  sectionId 
}: SituationImageProps) => {
  // Use the specific section for the main NS6 image
  const { getBackgroundImage } = useImageFetcher({ 
    section: section as any,
    limit: 1
  });
  
  // Use the provided fallback image if no image is found in Supabase
  const displayImageUrl = getBackgroundImage(imageUrl);

  return (
    <div className={cn(
      "bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20",
      isMobile ? "w-full md:w-1/2 mb-6 md:mb-0" : "w-full max-w-xl mb-8"
    )}>
      <div className="relative aspect-[16/9] w-full">
        <img
          src={displayImageUrl}
          alt="Beratung und Coaching"
          className="rounded-lg object-cover w-full h-full border-2 border-white/40"
        />
      </div>
    </div>
  );
};

export default SituationImage;
